import angular from 'angular';

import {ResetMobilePasswordComponent} from './resetMobilePassword.component';

export const ResetMobilePwModule = angular
        .module('mmsApp.pages.resetMobilePw', [
        ])
        .config(($stateProvider) => {
            'ngInject';
            $stateProvider
                .state('pages.resetMobilePw', {
                    data: {
                        isAuthRequired: false,
                    },
                    url: '/resetMobilePw?token&from',
                    params: {
                        token: '',
                        from: '',
                    },
                    component: ResetMobilePasswordComponent.name,
                    resolve: {
                        token: ($transition$) => {
                            return $transition$.params().token;
                        },
                        from: ($transition$) => {
                            return $transition$.params().from;
                        },
                    }
                });
        })
        .component(ResetMobilePasswordComponent.name, ResetMobilePasswordComponent.component)
        .name
    ;


// WEBPACK FOOTER //
// ./src/app/pages/resetMobilePw/resetMobilePassword.module.js